export default __webpack_public_path__ + "static/200-fa01f1555e5449a23a7d6d3f3a359778.jpg";